/* eslint-disable @typescript-eslint/naming-convention */
import {Box, Col, Row} from 'components/Grid';
import Picture from 'components/Picture';
import {Typography} from 'components/Typography';
import {useIsFixed} from 'core/hooks/useIsFixed';
import {getMediaSrc} from 'core/helpers/media';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {useProductBasePrice} from 'hooks/product/useProductBasePrice';
import {useProductResultPrice} from 'hooks/product/useProductResultPrice';
import {ProductRatingStickyHeader} from 'modules/product-card/components/ProductRatingStickyHeader';
import {selectProductData} from 'modules/product-card/selectors';
import classNames from 'classnames';
import {FC, useMemo, useRef} from 'react';
import style from './style.module.scss';
import {DiscountPercentLabel} from 'modules/product-card/components/DiscountPercentLabel';
import {ProductBuySticky} from 'modules/product-card/components/ProductBuySticky';
import {useSanitizeString} from 'core/hooks/useSanitizeString';
import {useIsProductFineAndRare} from 'modules/product-card/hooks/useIsProductFineAndRare';
import {ProductStickyHeaderPageName} from 'modules/product-card/constants';

interface IProps {
    page?: ProductStickyHeaderPageName;
}

const {Product} = ProductStickyHeaderPageName;

export const ProductTopDesktopPanel: FC<IProps> = ({page = Product}) => {
    const productData = useAppSelector(selectProductData);
    const {title, media} = productData || {};

    const topPanelRef = useRef<HTMLDivElement>(null);
    const isTopPanelFixed = useIsFixed({ref: topPanelRef, topOffset: 85});

    const imgSrc = useMemo(() => {
        return getMediaSrc(media?.imagePreview ?? '', {
            height: 56,
        });
    }, [media]);

    const basePrice = useProductBasePrice(productData);
    const resultPrice = useProductResultPrice(productData);
    const titleHtml = useSanitizeString(title);
    const isFineAndRareCategory = useIsProductFineAndRare();

    return (
        <div className={classNames(style.main, {[style.fixed]: isTopPanelFixed})} ref={topPanelRef}>
            <Box>
                <Row>
                    <Col className={style.column}>
                        <div className={style.topLeft}>
                            <div className={style.topImg}>
                                <Picture sources={{}} src={imgSrc} />
                            </div>
                            <div className={style.topTitle}>
                                <Typography
                                    className={style.title}
                                    dangerouslySetInnerHTML={{__html: titleHtml}}
                                    variant={'label-14-m'}
                                />
                                {!isFineAndRareCategory && (
                                    <div className={style.ratingWrapper}>
                                        <ProductRatingStickyHeader page={page} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className={style.topRight}>
                            <div className={style.priceArea}>
                                <div className={style.priceBaseContainer}>
                                    <Typography className={style.priceBase} variant={'label-12-r'}>
                                        {basePrice}
                                    </Typography>
                                    <DiscountPercentLabel type={'extra-small'} borderRadius={'4px'} />
                                </div>
                                <Typography variant={'price-24-b'}>{resultPrice}</Typography>
                            </div>
                            <div className={style.buyArea}>
                                <ProductBuySticky />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Box>
        </div>
    );
};
